import { createSelector } from 'reselect'

export const selectBusinessTravellerApprovalPolicyForUser = createSelector(
  (state: App.State) => state.businessTraveller.businessApprovalPolicy.policy,
  (state: App.State) => state.businessTraveller.currentBusinessAccount?.employee,
  (
    policy,
    employee,
  ): App.BusinessTraveller.ApprovalPolicy | null => {
    if (!employee || !policy) {
      return null
    }

    if (policy.resolvedForLoggedInEmployee) {
      return policy
    }

    if (!policy.travellers.includes(employee.id)) {
      return null
    }

    return policy
  },
)
